// pages/BankMainPage.js
import React, { useState, useMemo } from "react";
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Input,
  Button,
  Row,
  Col,
  Spinner,
  Alert,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";

import BreadcrumbAboveImage from "components/Common/BreadcrumbAboveImage";
import axiosInstance from "utils/axiosInstance";

import "./BankMainPage.css";

import bank10 from "assets/images/info/bank10.png";

const BankMainPage = ({ t }) => {

  document.title = "點數銀行主頁 | TheChart.AI";

  const navigate = useNavigate();


  return (
    <div className="bank-main-page page-content" 
      style={{ 
        backgroundImage: `url(${bank10})`,
        backgroundSize: "cover"
      }}
    >
      <Container fluid>
        <BreadcrumbAboveImage
          title={t("點數銀行主頁")}
          breadcrumbItems={[
            { title: t("我的 AI 應用主頁"), to: "/myInfo/dashboard" },
            { title: t("點數銀行主頁") }
          ]}
        />

        <Card>
          <CardBody className="bank-card-body">

            {/* Title */}
            <Row className="bank-card-title-row">
              <Col xs={12}>
                <CardTitle className="bank-card-title" style={{ fontSize: "18.5px" }}>點數銀行主頁</CardTitle>
              </Col>
            </Row>

            {/* First Two Links */}
            <Row className="bank-grid-outer-row">
              <Col xs={12} md={6} 
                className="bank-grid-outer-col left 
                  d-flex justify-content-center justify-content-md-end 
                  align-items-center align-items-md-end"
              >
                <div className="bank-grid top left"
                  onClick={() => navigate(`../myInfo/pointsRedemption`)}
                >
                  <div className="bank-content">
                    <p className="bank-content-text light">點數兌換</p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} 
                className="bank-grid-outer-col right 
                  d-flex justify-content-center justify-content-md-end 
                  align-items-center align-items-md-start"
              >
                <div className="bank-grid top right"
                  onClick={() => navigate(`../myInfo/pointsRecords`)}
                >
                  <div className="bank-content">
                    <p className="bank-content-text">兌換紀錄</p>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Second Two Links */}
            <Row className="bank-grid-outer-row">
              <Col xs={12} md={6} 
                className="bank-grid-outer-col left 
                  d-flex justify-content-center justify-content-md-start 
                  align-items-center align-items-md-end"
              >
                <div className="bank-grid bottom left"
                  onClick={() => navigate(`../myInfo/bankInfoSettings`)}
                >
                  <div className="bank-content">
                    <p className="bank-content-text">銀行帳戶設定</p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} 
                className="bank-grid-outer-col right 
                  d-flex justify-content-center justify-content-md-start 
                  align-items-center align-items-md-start"
              >
                <div className="bank-grid bottom right">
                  <div className="bank-content">
                    <p className="bank-content-text">即將開放，敬請期待</p>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Goldenhues: #BE9A60 */}

          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default withTranslation()(BankMainPage);


